
































































import { Component, Prop, Vue } from "vue-property-decorator";
import { deleteElement } from "@/api/delite/delite-element";

import FullRouteInfoList from "@/components/tabs/route_info/full-route-info-list.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { routeInfo } from "@/config/host.config";
import { IRouteCity, IRouteInfo } from "@/@types/routeInfo/route-info";

@Component({
  components: { FullRouteInfoList, BSwitch },
})
export default class RouteList extends Vue {
  @Prop({ type: Array, default: () => [] }) routeList!: Array<IRouteInfo>;
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;
  @Prop({ type: Array, default: () => [] }) shipsCode!: Array<string>;
  @Prop({ type: String, default: "" }) activeRoute!: string;
  @Prop({ type: Boolean, default: false }) config!: boolean;

  changeRoute(id: string, data: Partial<IRouteInfo>): void {
    this.$emit("changeRoute", id, data);
  }

  async dropRouleList(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("confirm.clear")),
        }
      );

      if (result !== true) return;
      for (const route of this.routeList) {
        if (route._id) this.deleteOneRoute(route._id);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  deleteOneRoute(id: string): void {
    const url = routeInfo.routes;
    deleteElement(id, url)
      .then(() => {
        this.$emit("deleteRoute", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  async deleteRoute(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("RouterInfo.confirm.deleteRoute")),
        }
      );

      if (result === true) {
        this.deleteOneRoute(id);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async changeHotelID(ship_code: string): Promise<void> {
    const auto = this.$store.getters.getAutoConfig.routeInfol;
    this.$cookies.set("hotelCode", ship_code);
    const type = {
      auto,
      ship_code,
    };
    const url = routeInfo.config;
    try {
      const config = await this.$axios.put(url, type);
      if (config.status === 200) {
        this.$store.dispatch("changeID", ship_code);
        this.$emit("createRouteList", auto);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
